export default {
  App: {
    DOCUMENT_CLICKED: 'App>document-clicked',
    USER_STATUS_UPDATED: 'App>user-status-updated',
    GOOGLE_USER_LOGGEDIN: 'App>google-user-loggedin',
    LOGIN_REQUEST: 'App>login-request',
    LOGIN_POPUP_CLOSED: 'App>login-popup-closed',
    ROUTER_TRANSITION_COMPLETED: 'App>router-transition-completed',
    INITIALIZED: 'App>initialized',
    CREATE_ACCOUNT_REQUEST: 'App>create-account-request',
    SUSPEND_UPDATE: 'App>suspend-update',
    RESUME_UPDATE: 'App>resume-update',
    DASHBOARD_UNMOUNTED: 'App>dashboard-unmounted',
    SHOW_PRELOADER: 'App>show-preloader',
    HIDE_PRELOADER: 'APP>hide-preloader',
    SHOW_NAVBAR: 'App>show-navbar',
    HIDE_NAVBAR: 'App>hide-navbar',
    SHOW_APP_MODAL: 'App>show-app-modal',
    USER_LOGEDIN: 'App>user-logedin',
    USER_PROFILE_PAGE_IS_CHANGED: 'App>user-profile-page-is-changed',
    MARKETPLACE_SEARCH_RELOAD: 'App>marketplace-search-reload',
    COLOR_CHANGED: 'App>color-changed',
    INTERVAL_ELAPSED: 'App>interval-elapsed'
  },
  Databank: {
    DATASET_CREATED: 'Databank.DATASET_CREATED'
  },
  Dashboard: {
    READY: 'Dashboard>>dashboard_ready',
    UPDATED: 'Dashboard>>dashboards_updated',
    STATE_UPDATED: 'Dashboard>>state_updated',
    TAB_UPDATED: 'Dashboard>>tab_updated',
    RENDERED: 'Dashboard>>rendered',
    WIDGET_RESIZE: 'WIDGET_RESIZE',
    WIDGET_RESIZE_STOP: 'WIDGET_RESIZE_STOP',
    LOADED: 'Dashboard>>loaded',
    UPDATE_NAME: 'Dashboard>>update-name',
    UPDATE_ALL_WIDGETS: 'App>update-all-widgets',
    TempEarthquakeGlobe: {
      OCCURED: 'OCCURED'
    },
    RESIZE_ALL_WIDGETS: 'Dashboard>>resize_all_widgets',
    CHART_LEGEND_CLICKED: 'Dashboard>>chart_legend_clicked',
    CHART_LEGEND_HOVERED: 'Dashboard>>chart_legend_hovered',
    CHART_LEGEND_UPDATED: 'Dashboard>>chart_legned_updated',
    WIDGET_CHANGED: 'Dashboard>>widget_changed',
    CHART_SLIDE: 'Dashboard>>chart_slide',
    CHART_ZOOM: 'Dashboard>>chart_zoom',
    CHART_REALTIME_BUTTON_CLICKED: 'Dashboard>>chart_realtime',
    CHART_RESET: 'Dashboard>>chart_reset',
    UPDATE_BAR_CHART_TOOLTIPS: 'Dashboard>>update_bar_chart_tooltips',
    AddWidget: {
      FIELD_DRAG_START: "Dashboard>>AddWidget.field_drag_start",
      FIELD_DRAG_END: "Dashboard>>AddWidget.field_drag_end",
      // LEGENDS_MODEL_UPDATED: 'Dashboard>>AddWidget.legends_model_updated',
      // LEGEND_SELECTED: 'Dashboard>>AddWidget.legend_selected',
      // LEGEND_DESELECTED: 'Dashboard>>AddWidget.legend_deselected',
      // SINGLE_LEGEND_UPDATED: 'Dashboard>>AddWidget.single_legend_updated',
      // LEGENDS_SORT_ORDER_CHANGED: 'Dashboard>>AddWidget.legends_sort_order_changed',
      // CHART_TYPE_PANEL_RENDERED: 'Dashboard>>AddWidget.chart_type_panel_rendered'
    },
    AUTO_RESIZE_WIDGET: 'Dashboard>>Auto_resize_widget',
    UPDATE_TOOLTIP: "Dashboard>>Update_tooltip",
    HIDE_TOOLTIP: "Dashboard>>Hide_tooltip",
    SET_START_TIME: "Dashboard>>Set_start_time",
    WIDGET_SEARCH_INDEX: 'App>widget-search-index',
    CONTROL_ADDED: 'Dashboard>>Control_added',
    CONTROL_UPDATED: 'Dashboard>>Control_updated',
    DASHBOARD_VARIABLE_CHANGED: 'Dashboard>>Variable_changed',
    DASHBOARD_VARIABLE_UPDATED: 'Dashboard>>Variable_updated',
    EDIT_CONTROL_WIDGET: 'Dashboard>>edit_control_widget',
    UPDATE_DASHBOARD_STATE: 'Dashboard>>UPDATE_DASHBOARD_STATE',
    DASHBOARD_LOCK_TOGGLED: 'Dashboard>>DASHBOARD_LOCK_TOGGLED',
    UPDATE_TIME_TICK_FORMAT: 'Dashboard>>UPDATE_TIME_TICK_FORMAT',
    WIDGET_SNAPSHOT_LOADED: 'Dashboard>>WIDGET_SNAPSHOT_LOADED',
    OPEN_SUBSCRIPTION_POPUP: 'Dashboard>>OPEN_SUBSCRIPTION_POPUP',
    ADD_VERTICAL_SEPARATOR_WIDGET: 'Dashboard>>ADD_VERTICAL_SEPARATOR_WIDGET',
    TRADING_ViEW_INDICATOR_VALUE_CHANGED: 'Dashboard>>TRADING_ViEW_INDICATOR_VALUE_CHANGED',
    STANDALONE_DASHBOARD_RESIZED: 'STANDALONE_DASHBOARD_RESIZED',
    ADD_WIDGET_UPDATED: 'ADD_WIDGET_UPDATED'
  },
  Studio: {
    SAVE_STUDIO_OUTPUT_MODEL: 'Studio>>save-studio-output-model',

    DATA_STREAM_REMOVED: 'Studio>>data-stream-removed',
    DATA_STREAM_REF_UPDATED: 'Studio>>data-stream-ref-updated',
    INPUT_MODEL_LOADED: "Studio>>accordion_loaded",
    CONTAINER_RESIZED: "Studio>>container_resized",
    OUTPUT_MODEL_LOADED: "Studio>>output_model_loaded",
    OUTPUT_FIELD_SELECTED: "Studio>>output_field_seleted",
    CHART_MODEL_REMOVED: "Studio>>chart_model_removed",
    STUDIO_OUTPUT_MODEL_UPDATED: "Sutiod>>studio_output_model_updated",
    WIDGET_LOADED: "Sutiod>>studio_widget_loaded",
    OPEN_EDITOR: 'Studio>>open-editor',
    STUDIOS_LOADED: "Studio>>studios-loaded",
    CHART_MODEL_RECEIVED: "Studio>>chart_model_received",
    INPUT_MODEL_RECEIVED: "Studio>>input_model_received",
    OUTPUT_MODEL_RECEIVED: "Studio>>output_model_received",
    SAVE_FIELD_CODE: "Studio>>save_field_code",
    FIELD_DRAG_END: "Studio>>field_drag_end",
    SPREADSHEET_CELL_CLICKED: "Spreadsheet>>cell_clicked"

  },
  InsightSearch: {
    SEARCH_PARAMS_CHANGED: 'InsightSearch>>search-params-changed',
    INSIGHTS_LOADED: 'InsightSearch>>insights-loaded',
    BEGIN_PERFORM_SEARCH: 'InsightSearch>>begin-perform-search'
  },
  Subscription: {
    CHART_RESET: 'Subscription>>chart_reset',
    WIDGET_TYPE_CHANGED: 'Subscription>>widget_type_changed',
    TEXTUAL_WIDGET_UPDATED: 'Subscription>>textual_widget_updated'
  },
  Widget: {
    HISTORY_MODE_TOGGLED: 'Widget>>history_mode_toggled',
    REALTIME_RESUMED: 'Widget>>realtime_resumed'
  }
};



// WEBPACK FOOTER //
// ./src/core/constants/internalEvent.js